import React, { useEffect } from "react";
import Header from "../../components/Header/Header";
import Pipelinecard from "./Pipelinecard";
import CustomerMetricsAccordian from "../../components/psfSalesService/CustomerMetricsAccordian";
import { useLocation, useSearchParams } from "react-router-dom";
import WaterMark from "../../components/WaterMark";
import CryptoJS from "crypto-js";

const Index = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [finalArn, setFinalArn] = React.useState(null);

  const encryptedParArn = searchParams.get("parArn");
  const encryptedChildArn = searchParams.get("childArn");
  const isDealer = searchParams.get("isDealer");
  const isVehicle360 = searchParams.get("isVehicle360");

  const decryptArn = (encryptedArn) => {
    try {
      const base64 = encryptedArn
        .replace(/-/g, "+")
        .replace(/_/g, "/")
        .padEnd(
          encryptedArn.length + ((4 - (encryptedArn.length % 4)) % 4),
          "="
        );

      const decrypted = CryptoJS.AES.decrypt(
        base64,
        process.env.REACT_APP_DEALER_SECRET_KEY
      ).toString(CryptoJS.enc.Utf8);

      return decrypted || null;
    } catch (err) {
      console.error("Decryption failed:", err);
      return null;
    }
  };


  useEffect(() => {
    // STEP 1: Read from URL first
    if (isDealer !== "true") return;

    let encryptedArn = searchParams.get("parArn");

    if (!encryptedArn || encryptedArn.trim() === "") {
      encryptedArn = localStorage.getItem("incoming_parArn");
    }
    // console.log('---------encryptedArn2----------', encryptedArn);

    // STEP 3: Save encryptedArn only when valid
    if (encryptedArn && encryptedArn.trim() !== "") {
      localStorage.setItem("incoming_parArn", encryptedArn);

      // const decryptedArn = decryptArn(encryptedArn);
      const decryptedArn = encryptedArn;

      // STEP 4: Store decrypted ARN safely
      if (decryptedArn && decryptedArn.trim() !== "") {
        localStorage.setItem("parArn", decryptedArn);
        localStorage.setItem("arn", decryptedArn);
        localStorage.setItem("superArn", decryptedArn);

        setFinalArn(decryptedArn);
      }
    }

    // Store dealer flag
    if (isDealer !== null && isDealer !== "") {
      localStorage.setItem("isDealer", isDealer);
    }

  }, [encryptedParArn, isDealer]);


  useEffect(() => {
    if (isVehicle360 !== "true") return;
    const encryptedChildArn = searchParams.get("childArn");
    let encryptedArn = encryptedChildArn;

    if (!encryptedArn || encryptedArn.trim() === "") {
      encryptedArn = localStorage.getItem("incoming_childArn");
    }

    if (encryptedArn && encryptedArn.trim() !== "") {
      localStorage.setItem("incoming_childArn", encryptedArn);

      // decrypt if needed
      const decryptedArn = encryptedArn; // or decryptArn(encryptedArn)

      if (decryptedArn && decryptedArn.trim() !== "") {
        localStorage.setItem("childArn", decryptedArn);
        //localStorage.setItem("arn", decryptedArn);
        setFinalArn(decryptedArn);
      }
    }
  }, [isVehicle360, encryptedChildArn]);

  // console.log('------------------finalArn', finalArn);
  return (
    <>
      <WaterMark />
      <div>
        <Header heading={"Pipeline & Financials"} />

        {/* {!finalArn ? (
          <p className="p-4 text-center">Loading data...</p> // avoids stale UI
        ) : ( */}
        <div className="mr-2 mb-2 w-full bg-white rounded-4xl shadow-md rounded-[10px] border-gray-300">
          <div className="mt-2 m-3">
            <CustomerMetricsAccordian />
          </div>

          <Pipelinecard />
        </div>
        {/* )} */}
      </div>
    </>
  );
};

export default Index;
